
export class Helper {
  static randomInt(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  static getCurrentDomain(): string {
    return window.location.hostname.replace(/www./i, '')
  }

  static getParsedErrors(strigifiedErrors): string {
    console.log(strigifiedErrors)
    return '<ul><li>test</li></ul>'
  }
}
